import { Button, Form, Input, Row, Select, Space } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWeeksOnlyYear } from '../../../../appRedux/actions';
import { getGeneralCosmetologicFees } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { buildFortnightRangeOptions } from '../../../../util/fortnighltyOptions';

export const GeneralCosmetologicFeesFilters = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { fortnightlysWeeks } = useSelector((state) => state.fortnightlys);
  const [fortnightlyRangeYearValue, setFortnightlyRangeYearValue] =
    useState('');

  const onFortnightlyRangeYearChange = async (e) => {
    const value = e.target.value;
    setFortnightlyRangeYearValue(value);

    form.setFieldsValue({ fortnightlyRange: undefined });

    if (value && value.length === 4 && /^\d{4}$/.test(value)) {
      await dispatch(getWeeksOnlyYear(value));
    }
  };

  const onSubmit = (values) => {
    if (values.fortnightlyRangeYear) {
      values.fortnightlyRangeYear = Number(values.fortnightlyRangeYear);
    }

    dispatch(getGeneralCosmetologicFees(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="fortnightlyRangeYear">
            <Input
              placeholder={placeHolders.typeYear}
              style={{ width: '150px' }}
              value={fortnightlyRangeYearValue}
              onChange={onFortnightlyRangeYearChange}
              maxLength={4}
            />
          </Form.Item>

          <Form.Item name="dates">
            <Select
              placeholder={placeHolders.fortnightly}
              style={{ width: '350px' }}
              disabled={!fortnightlyRangeYearValue}
              options={buildFortnightRangeOptions(fortnightlysWeeks)}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
